import React from 'react';
import { Button, Link, useRecordContext } from 'react-admin';

const CreateSDOButton = () => {
    const record = useRecordContext();
return (
    <Button
        component={Link}
        to={{
            pathname: '/sap_sdo_for_orders/create',
            state: {
              order: record,
            },
        }}
        className="create-sdo"
    >
        <span><i>+</i> Create a Single Delivery</span>      
    </Button>
);
    }

export default CreateSDOButton;